// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Footer.css'; // create this file

// const Footer = () => {
//   return (
//     <footer className="footer bg-light py-5 w-100">
//       <div className="container">
//         <div className="d-flex justify-content-between flex-wrap">
          
//           {/* Online Shopping */}
//           <div className="footer-col">
//             <h5 className="text-uppercase mb-3">Online Shopping</h5>
//             <ul className="list-unstyled">
//               <li><a href="#">Men</a></li>
//               <li><a href="#">Women</a></li>
//               <li><a href="#">Kids</a></li>
//               <li><a href="#">Home & Living</a></li>
//               <li><a href="#">Beauty</a></li>
//               <li><a href="#">Gift Cards</a></li>
//               {/* <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
//             </ul>
//           </div>

//           {/* Useful Links */}
//           {/* <div className="footer-col">
//             <h5 className="text-uppercase mb-3">Useful Links</h5>
//             <ul className="list-unstyled">
//               <li><a href="/faq">FAQ</a></li>
//               <li><a href="/policy_footer">Privacy Poilcy</a></li>
//               <li><a href="/security">Security</a></li>
//               <li><a href="shipping_policy">Shipping Poilcy</a></li>
//               <li><a href="cancel_policy">Cancellation & Return Poilcy</a></li>
//               <li><a href="refresal">Grievance Redressal</a></li>
//               <li><a href="contact-footer">Contact Us</a></li>
//               <li><a href="#">Returns</a></li>
//               <li><a href="#">Track Order</a></li>
//               <li><a href="#">Careers</a></li>
//             </ul>
//           </div> */}

//               <div className="footer-col">
//             <h5 className="text-uppercase mb-3">About</h5>
//             <ul className="list-unstyled">
//               <li><a href="/about">About Us</a></li>
//               <li><a href="/story">Stories</a></li>
//               <li><a href="#">Careers</a></li>
//               <li><a href="/contact-footer">Contact</a></li>
//               {/* <li><a href="#">Beauty</a></li>
//               <li><a href="#">Gift Cards</a></li>
//               <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
//             </ul>
//           </div>
            
//             <div className="footer-col">
//             <h5 className="text-uppercase mb-3">Help</h5>
//             <ul className="list-unstyled">
//               <li><a href="/PaymentsPage">Payment</a></li>
//               <li><a href="/shipping_policy">Shipping</a></li>
//               <li><a href="/faq">FAQ</a></li>
//               {/* <li><a href="#">Home & Living</a></li>
//               <li><a href="#">Beauty</a></li>
//               <li><a href="#">Gift Cards</a></li>
//               <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
//             </ul>
//           </div>

//               <div className="footer-col">
//             <h5 className="text-uppercase mb-3">Consumer Policy</h5>
//             <ul className="list-unstyled">
//               <li><a href="/TermsOfUse">Terms of use</a></li>
//                 <li><a href="/policy_footer">Privacy</a></li>
//               <li><a href="/security">Security</a></li>
//               <li><a href="/cancel_policy">Cancellation and Return Policy</a></li>
//                <li><a href="/refresal">Grievance Redressal</a></li>
//                <li><a href="#">Sitemap</a></li>
             
//               {/* <li><a href="#">Gift Cards</a></li>
//               <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
//             </ul>
//           </div>
//           {/* App & Social */}
//           <div className="footer-col">
//             <h6>Keep in touch</h6>
//             <div className="social-links">
//               <a href="#"><i className="fab fa-facebook-f"></i></a>
//               <a href="#"><i className="fab fa-twitter"></i></a>
//               <a href="#"><i className="fab fa-instagram"></i></a>
//               <a href="#"><i className="fab fa-youtube"></i></a>
//             </div>
//           </div>

//           {/* Promise Section */}
//           {/* <div className="footer-col">
//             <div className="footer-promise d-flex align-items-center mb-3">
//               <img src="https://constant.myntassets.com/web/assets/img/6c3306ca-1efa-4a27-8769-3b69d16948741574602902452-original.png" alt="" width="50" className="me-2" />
//               <div>
//                 <strong>100% ORIGINAL</strong>
//                 <div>guarantee for all products at myntra.com</div>
//               </div>
//             </div>
//             <div className="footer-promise d-flex align-items-center">
//               <img src="https://constant.myntassets.com/web/assets/img/ef05d6ec-950a-4d01-bbfa-e8e5af80ffe31574602902427-30days.png" alt="" width="50" className="me-2" />
//               <div>
//                 <strong>Return within 7 days of receiving your order.</strong>
//                 <div>of receiving your order</div>
//               </div>
//             </div>
//           </div> */}
     
//         </div>
//       </div>
//       <div className="text-center mt-4">
//        ©2025-2026 Garshya.com
//    </div>
//     </footer>
//   );
// };

// export default Footer;











// 02-11-2026
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

/* ------------------------------------------------------------------
   LOGO
   Abhi placeholder link hai. Baad mein image public/images/ mein rakho:
   const FOOTER_LOGO_SRC = "/images/footer-logo.png";
------------------------------------------------------------------- */
const FOOTER_LOGO_SRC = "/img/logoN1.jpeg";

/* ------------------------------------------------------------------
   BOTTOM ILLUSTRATION
   desktop_footer_new.webp ko public/images/ folder mein rakho.
------------------------------------------------------------------- */
const FOOTER_IMAGE_SRC = "/img/desktop_footer_new.webp";

/* ---------------- Links (tumhare original footer wale hi) ---------------- */
const FOOTER_COLUMNS = [
  {
    title: "Online Shopping",
    links: [
      { label: "Men", path: "#" },
      { label: "Women", path: "#" },
      { label: "Kids", path: "#" },
      { label: "Home & Living", path: "#" },
      { label: "Beauty", path: "#" },
      { label: "Gift Cards", path: "#" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "About Us", path: "/about" },
      { label: "Stories", path: "/story" },
      { label: "Careers", path: "#" },
      { label: "Contact", path: "/contact-footer" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Payment", path: "/PaymentsPage" },
      { label: "Shipping", path: "/shipping_policy" },
      { label: "FAQ", path: "/faq" },
    ],
  },
  {
    title: "Consumer Policy",
    links: [
      { label: "Terms of use", path: "/TermsOfUse" },
      { label: "Privacy", path: "/policy_footer" },
      { label: "Security", path: "/security" },
      { label: "Cancellation and Return Policy", path: "/cancel_policy" },
      { label: "Grievance Redressal", path: "/refresal" },
      { label: "Sitemap", path: "#" },
    ],
  },
];

/* Social icons (original wale Font Awesome classes) */
const SOCIAL_LINKS = [
  { icon: "fab fa-facebook-f", label: "Facebook", url: "#" },
  { icon: "fab fa-twitter", label: "Twitter", url: "#" },
  { icon: "fab fa-instagram", label: "Instagram", url: "#" },
  { icon: "fab fa-youtube", label: "YouTube", url: "#" },
];

const Footer = () => {
  return (
    <footer className="footerparatha-root">
      <div className="footerparatha-inner">
        <div className="footerparatha-grid">
          {/* Logo + Keep in touch */}
          <div className="footerparatha-brand">
            <Link to="/" className="footerparatha-logo" aria-label="Home">
              <img src={FOOTER_LOGO_SRC} alt="logo" />
            </Link>

            <div className="footerparatha-touch">
              <h6 className="footerparatha-touch-title">Keep in touch</h6>
              <div className="footerparatha-social">
                {SOCIAL_LINKS.map((s) => (
                  <a
                    key={s.label}
                    href={s.url}
                    aria-label={s.label}
                    className="footerparatha-social-link"
                  >
                    <i className={s.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Link columns */}
          {FOOTER_COLUMNS.map((col) => (
            <div className="footerparatha-col" key={col.title}>
              <h5 className="footerparatha-heading">{col.title}</h5>
              <ul className="footerparatha-list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.path === "#" ? (
                      <a href="#" className="footerparatha-link">
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.path} className="footerparatha-link">
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* <p className="footerparatha-copy">©2025-2026 Garshya.com</p> */}
      </div>

      {/* Bottom illustration */}
      <img
        src={FOOTER_IMAGE_SRC}
        alt=""
        className="footerparatha-illustration"
        loading="lazy"
        draggable={false}
      />
    </footer>
  );
};

export default Footer;